import InnerBanner from "./InnerBanner";
import Contactimg from "../../assets/img/contact.jpg";
import { Helmet } from "react-helmet-async";
import HelemtHead from "../commons/HelmetHead";

const Contact = () => {
    return (
        <>
            <div className="page page_home">
                {/* <HelemtHead title={'Contact'} name={'description'} desc={'Some random description'} /> */}
                <Helmet>
                    <title>Contact</title>
                    <meta name='description' content='Contact us at First Resource' />
                    <meta name="keywords"
                        content="FirstResource, firstresource, first resource, recruitment, recruiters, talent acquisition, hiring, staffing, job placement, workforce solutions, recruitment agency, employment services, candidate sourcing, recruitment solutions, talent management, HR services, recruitment consultancy" />
                </Helmet>
                <InnerBanner />
                <div className="section contact">
                    <div className="container contactin px-4 px-lg-0">
                        <div className="row align-items-center justify-content-end">

                            <div className="col-12 col-lg-8">
                                <div className="address1">
                                    <div className="adrsdets">
                                        <div className="fs-4">
                                            <p><small >Registered Address</small></p>
                                            <p> No. 37, Sector 15A, Noida 201301</p>


                                            <p>+91-98104 03020<br />
                                                +91-88260 29449</p>
                                            <p>connect@firstresource.in</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}
export default Contact;